import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import './ReservationFormActions.scss';

const ReservationFormActions = ({
    onCancel,
    loading = false,
    isEditing = false
}) => {
    const { t } = useTranslation();

    return (
        <div className="form-actions">
            {onCancel && (
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn btn-secondary"
                    disabled={loading}
                >
                    {t('common.cancel')}
                </button>
            )}
            <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
            >
                {loading ? t('common.loading') : (isEditing ? t('common.save') : t('reservation.reserve'))}
            </button>
        </div>
    );
};

export default ReservationFormActions;
